import React from "react";
import ReactDOM from "react-dom/client";
import "reactjs-popup/dist/index.css";
import App from "./App";
import "swiper/css";
import "swiper/css/pagination";
import "react-image-gallery/styles/scss/image-gallery.scss";
import "react-image-crop/src/ReactCrop.scss";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import store from "store/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <React.StrictMode>
      <Provider store={store}>
        <App />
        <ToastContainer />
      </Provider>
    </React.StrictMode>
  </GoogleOAuthProvider>
);
